import { useState } from "react";
import { Hotel } from "lucide-react";
import { CrudPage } from "../components/crud/CrudPage";
import { useOpciones } from "../hooks/useOpciones";
import { Badge } from "../components/ui/Badge";

const tiposEspacio = ["JAULA", "CUARTO", "CORRAL", "PATIO"].map((t) => ({ value: t, label: t }));
const tiposHospedaje = [
  { value: "HOTEL", label: "Hotel" },
  { value: "GUARDERIA", label: "Guardería" },
];
const estados = ["RESERVADO", "EN_CURSO", "FINALIZADO", "CANCELADO"].map((e) => ({ value: e, label: e.replace("_", " ") }));

export default function Hospedaje() {
  const [tab, setTab] = useState<"hospedajes" | "espacios">("hospedajes");
  const { opciones: clientes } = useOpciones("/clientes", (c) => c.nombre);
  const { opciones: mascotas } = useOpciones("/mascotas", (m) => m.nombre);
  const { opciones: espacios } = useOpciones("/espacios", (e) => e.nombre);

  return (
    <div>
      <div className="mb-4 flex gap-2 border-b border-slate-100">
        <button
          className={`border-b-2 px-4 py-2 text-sm font-medium ${tab === "hospedajes" ? "border-brand-500 text-brand-600" : "border-transparent text-slate-500"}`}
          onClick={() => setTab("hospedajes")}
        >
          Reservas
        </button>
        <button
          className={`border-b-2 px-4 py-2 text-sm font-medium ${tab === "espacios" ? "border-brand-500 text-brand-600" : "border-transparent text-slate-500"}`}
          onClick={() => setTab("espacios")}
        >
          Jaulas / cuartos
        </button>
      </div>

      {tab === "hospedajes" ? (
        <CrudPage
          resource="/hospedajes"
          seccion="hospedaje"
          titulo="Hotel y guardería"
          icono={<Hotel size={20} />}
          descripcion="Reservas de huéspedes, disponibilidad y servicios adicionales."
          nombreSingular="hospedaje"
          campos={[
            { name: "clienteId", label: "Cliente", type: "select", options: clientes, required: true },
            { name: "mascotaId", label: "Mascota", type: "select", options: mascotas, required: true },
            { name: "tipo", label: "Tipo", type: "select", options: tiposHospedaje, default: "HOTEL" },
            { name: "espacioId", label: "Espacio asignado", type: "select", options: espacios },
            { name: "fechaEntrada", label: "Fecha de entrada", type: "date", required: true },
            { name: "fechaSalida", label: "Fecha de salida", type: "date" },
            { name: "alimentacionEspecial", label: "Alimentación especial" },
            { name: "estado", label: "Estado", type: "select", options: estados },
            { name: "costoTotal", label: "Costo total", type: "number" },
          ]}
          columnas={[
            { key: "mascota", label: "Mascota", render: (r: any) => r.mascota?.nombre },
            { key: "tipo", label: "Tipo" },
            { key: "fechaEntrada", label: "Entrada", render: (r: any) => new Date(r.fechaEntrada).toLocaleDateString("es-MX") },
            { key: "estado", label: "Estado", render: (r: any) => <Badge color="azul">{r.estado}</Badge> },
          ]}
        />
      ) : (
        <CrudPage
          resource="/espacios"
          seccion="espacios"
          titulo="Jaulas, cuartos y corrales"
          descripcion="Espacios disponibles para hospedar mascotas."
          nombreSingular="espacio"
          campos={[
            { name: "nombre", label: "Nombre", required: true },
            { name: "tipo", label: "Tipo", type: "select", options: tiposEspacio, default: "JAULA" },
            { name: "capacidad", label: "Capacidad", type: "number", default: 1 },
            { name: "disponible", label: "Disponible", type: "checkbox", default: true },
          ]}
          columnas={[
            { key: "nombre", label: "Nombre" },
            { key: "tipo", label: "Tipo" },
            { key: "capacidad", label: "Capacidad" },
            { key: "disponible", label: "Estado", render: (r: any) => <Badge color={r.disponible ? "verde" : "rojo"}>{r.disponible ? "Disponible" : "Ocupado"}</Badge> },
          ]}
        />
      )}
    </div>
  );
}
